<template>
  <div>
    <a-row :gutter="[8,16]">
      <a-col>
        <div class="simiot-card-box">
          <!-- 操作详情字段 -->
          <batch-operation-record-sim-cards-import-info
            :batch-operation-record-info="batchOperationRecordInfo"
          />
        </div>
      </a-col>
    </a-row>

    <a-row :gutter="[8,16]">
      <a-col>
        <div class="simiot-card-box">
          <!-- 操作详情列表搜索 -->
          <batch-operation-record-common-details-search @submit="submitSearch" />

          <div class="simiot-table-operation-buttons">
            <a-space>
              <a-button
                type="primary"
                @click="showReImportModal"
                v-if="isShowReImportMenu()"
              >重新入库</a-button>
              <a-button type="primary" @click="exportData">导出</a-button>
            </a-space>
          </div>

          <!-- 操作详情列表 -->
          <batch-operation-record-common-details-list
            :data="tableData"
            :loading="tableLoading"
          />

          <pagination
            v-show="pagination.total_count > 0"
            :total-count="pagination.total_count"
            :page.sync="query.page"
            :per-page.sync="query.per_page"
            @change="fetchData"
          />

          <!-- 重新入库 -->
          <batch-operation-record-sim-cards-re-import
            v-if="isShowReImportModal"
            :visible.sync="isShowReImportModal"
            :batch-operation-record-id="batchOperationRecordInfo.id"
            @completed="fetchData"
          />
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { findBatchOperationDetails, exportBatchOperationDetails } from '@/api/batch_operation_detail'
import BatchOperationRecordSimCardsImportInfo from '@/views/batch_operation_records/detail/import_cards/Info'
import Pagination from '@/components/Pagination'
import BatchOperationRecordCommonDetailsSearch from '@/views/batch_operation_records/detail/CommonDetailsSearch'
import BatchOperationRecordCommonDetailsList from '@/views/batch_operation_records/detail/CommonDetailsList'
import { hasPermission } from '@/utils/permission'
import { exportExcel } from '@/api/excel'

export default {
  name: 'BatchOperationRecordImportCardsShow',
  components: {
    BatchOperationRecordSimCardsReImport: () => import('@/views/batch_operation_records/detail/import_cards/ReImport'),
    BatchOperationRecordCommonDetailsSearch,
    Pagination,
    BatchOperationRecordCommonDetailsList,
    BatchOperationRecordSimCardsImportInfo
  },
  props: {
    batchOperationRecordInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tableLoading: true,
      tableData: [],
      isShowReImportModal: false,
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    isOperationFailed() {
      return this.batchOperationRecordInfo.failure_count > 0
    }
  },
  methods: {
    isShowReImportMenu() {
      return this.isOperationFailed && hasPermission('sim_card_inventories/import')
    },

    fetchData() {
      this.tableLoading = true
      const params = Object.assign({ batch_operation_record_id: this.batchOperationRecordInfo.id }, this.query)
      findBatchOperationDetails(params).then((res) => {
        this.tableData = res.data
        this.pagination = res.pagination
        this.tableLoading = false
      })
    },

    submitSearch(search) {
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    showReImportModal() {
      this.isShowReImportModal = true
    },

    exportData() {
      const params = Object.assign({ batch_operation_record_id: this.batchOperationRecordInfo.id }, this.query)
      exportBatchOperationDetails(params).then((res) => {
        if (res.code === 0 && res.data.is_direct_download === true) {
          exportExcel(res.data.id, res.data.file_name)
        }
      })
    }
  }
}
</script>

